module.exports = __webpack_public_path__ + "static/media/filterActive.ebabf191.svg";